import script from "./AccordionComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AccordionComponent.vue?vue&type=script&setup=true&lang=js"

import "./AccordionComponent.vue?vue&type=style&index=0&id=e17c602e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e17c602e"]])

export default __exports__